var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-h5 q-pb-md q-my-md text-left fields-tab-header"},[_vm._v("Colours")]),_c('div',{staticClass:"settings-wrapper row"},_vm._l((_vm.colours),function(colour){return _c('colour-picker',{key:colour.label,attrs:{"colour":colour}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }